import login from './login';

export default {
  language: 'sr-Cyrl-CS',
  country: 'rs',
  name: 'Српски (ћирилица)',
  embeddedLocale: login,
};
